export default {
  'Watermark': 'Водяной знак',
  'Add Watermark Selection': 'Добавить выбор водяного знака',
}